import { defaultFormAddress, ukraineOption } from '../../constants';
import { ClientTypes } from '~/constants/clientTypes.ts';

export const EMPTY_GOVERNING_PERSON = {
  lastName: null,
  firstName: null,
  middleName: null,
  identificationNumber: null,
  birthDate: null,
  citizenshipCountry: ukraineOption,
  residenceCountry: ukraineOption,
  position: null,
  address: defaultFormAddress,
};

export const testDataManagementStructure = {
  type: ClientTypes.LEGAL_RESIDENT,
  lastName: 'ЧЕЙПЕШ',
  firstName: 'ЛАРИСА',
  middleName: 'ЛАРИСА',
  birthDate: '06.11.1987',
  identificationNumber: '3739601277',
  foreignTaxNumber: null,
  citizenshipCountry: ukraineOption,
  residenceCountry: ukraineOption,
  birthCountry: ukraineOption,
  birthPlace: 'М. КИЇВ УКРАЇНА',
  documents: {
    documentType: { label: 'Паспорт громадянина України', value: '1' },
    registryRecord: null,
    documentSeries: 'АА',
    documentNumber: '123456',
    issueDate: '12.08.1998',
    documentExpiryDate: null,
    issuingAuthority: 'HT',
  },
  position: { value: '17', label: 'Економіст' },
  address: {
    registrationAddress: {
      address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
      country: ukraineOption,
      postalCode: '12345',
      region: { value: '26', label: 'м.Київ' },
      district: null,
      city: { label: 'м.Київ', value: '191919' },
      street: { label: 'вул. Хрещатик', value: '25979' },
      houseNumber: '22',
      building: null,
      apartment: null,
      codeAddress: 'UA80000000000093317',
    },
    permanentAddress: {
      address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
      country: ukraineOption,
      postalCode: '12345',
      region: { value: '26', label: 'м.Київ' },
      district: null,
      city: { label: 'м.Київ', value: '191919' },
      street: { label: 'вул. Хрещатик', value: '25979' },
      houseNumber: '22',
      building: null,
      apartment: null,
      codeAddress: 'UA80000000000093317',
    },
    coincidences: true,
  },
  isAccountHolder: false,
  hasNoGoverningPersons: false,
  isHeadNew: false,
  isInBankBlackList: false,
  isInTerList: false,
  governingPersons: [
    {
      lastName: 'Ромашка',
      firstName: 'Іван',
      middleName: null,
      identificationNumber: null,
      birthDate: '27.07.1990',
      citizenshipCountry: ukraineOption,
      residenceCountry: ukraineOption,
      position: { value: '16', label: 'Бухгалтер' },
      address: {
        registrationAddress: {
          address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
          country: ukraineOption,
          postalCode: '12345',
          region: { value: '26', label: 'м.Київ' },
          district: null,
          city: { label: 'м.Київ', value: '191919' },
          street: { label: 'вул. Хрещатик', value: '25979' },
          houseNumber: '22',
          building: null,
          apartment: null,
          codeAddress: 'UA80000000000093317',
        },
        permanentAddress: {
          address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
          country: ukraineOption,
          postalCode: '12345',
          region: { value: '26', label: 'м.Київ' },
          district: null,
          city: { label: 'м.Київ', value: '191919' },
          street: { label: 'вул. Хрещатик', value: '25979' },
          houseNumber: '22',
          building: null,
          apartment: null,
          codeAddress: 'UA80000000000093317',
        },
        coincidences: true,
      },
    },
  ],
};

export const SYNC_TRIGGER_FIELDS = [
  'lastName',
  'firstName',
  'middleName',
  'identificationNumber',
  'position',
  'isAccountHolder',
] as const;
